import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login/Login";
import ProtectedRoute from "./ProtectedRoute";

const Planning = lazy(() => import("./pages/planning/Planning"));
const LitePlanning = lazy(() => import("./pages/display/LitePlanning"));

function Loading() {
    return <div style={{ minHeight: "100vh", background: "#07131f" }} />;
}

export default function Router() {
    const params = new URLSearchParams(window.location.search);
    const urlLogin = params.get("login") || params.get("token") || "";
    let savedLogin = "";
    try {
        const savedUser = JSON.parse(localStorage.getItem("am_user") || "null");
        savedLogin = savedUser?.login || savedUser?.username || "";
    } catch {
        savedLogin = "";
    }
    const isTableauUser = String(urlLogin || savedLogin).toLowerCase() === "tableau";

    return (
        <Suspense fallback={<Loading />}>
        <Routes>
            {/* Redirige la racine vers le planning (qui renverra vers login si pas de token) */}
            <Route path="/" element={<Navigate to={isTableauUser ? "/affichage" : "/planning"} replace />} />

            <Route path="/login" element={<Login />} />

            <Route
                path="/planning"
                element={
                    isTableauUser
                        ? <Navigate to="/affichage" replace />
                        : <ProtectedRoute><Planning /></ProtectedRoute>
                }
            />

            <Route
                path="/affichage"
                element={
                    <ProtectedRoute>
                        <LitePlanning />
                    </ProtectedRoute>
                }
            />

            {/* Redirige tout le reste vers le planning */}
            <Route path="*" element={<Navigate to={isTableauUser ? "/affichage" : "/planning"} replace />} />
        </Routes>
        </Suspense>
    );
}
